module.exports = __webpack_public_path__ + "static/first_close1-c500969da109bab9fbf4950aa20fe717.png";